import React, { useState } from "react";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { Col, Image } from "react-bootstrap";
import { isLoggedIn } from '../../reducers/auth';
import { resolveImageUrl } from '../../utils/imageUrl';

const PRICING_TYPES = { FLAT: 1, QUANTITY: 2, BILL_LATER: 3 };

const FeaturedProduct = (props) => {
  const apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const loginStatus = useSelector(isLoggedIn);

  const removeItem = () => {
    if (props.product.isPrintItem) {
      props.removeFeaturedItem(props.product.printItemId || props.product.id, true);
    } else {
      props.removeFeaturedItem(props.product.id);
    }
  };

  if (props.product.isPrintItem) {
    const item = props.product;
    const getImageUrl = (url) => {
      if (!url) return null;
      if (url.startsWith("http")) return url;
      if (url.includes("uploads")) return apiUrl + url;
      return url;
    };

    const getPriceDisplay = () => {
      if (!loginStatus) return null;
      if (item.pricingType === PRICING_TYPES.QUANTITY && item.quantityPrices?.length > 0) {
        const prices = item.quantityPrices.map(qp => qp.price);
        const minPrice = Math.min(...prices);
        const maxPrice = Math.max(...prices);
        if (minPrice === maxPrice) return `$${minPrice.toFixed(2)}`;
        return `$${minPrice.toFixed(2)} - $${maxPrice.toFixed(2)}`;
      }
      if (item.pricingType === PRICING_TYPES.BILL_LATER) return "Billed Later";
      return item.price ? `$${item.price.toFixed(2)}` : null;
    };

    return (
      <Col xs={12} sm={6} md={4} lg={2} style={{ paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4 }}>
        <div className="product">
          <div className="main-image-container modelImage">
            <div style={{ display: "inline-block", position: "relative" }}>
              <Image
                src={getImageUrl(item.imageUrl || item.thumbUrl)}
                fluid
                style={{ maxHeight: 200, objectFit: "contain" }}
              />
            </div>
          </div>
          <div className="title">{item.title}</div>
          {getPriceDisplay() && <div className="price">{getPriceDisplay()}</div>}
          <div style={{ display: "flex", height: "100%" }}>
            <div style={{ width: "100%", textAlign: "center", alignSelf: "flex-end" }}>
              <Button onClick={removeItem}>Remove</Button>
            </div>
          </div>
        </div>
      </Col>
    );
  }

  return (
    <Col xs={12} sm={6} md={4} lg={2} style={{ paddingRight: 4, paddingLeft: 4, paddingBottom: 4, paddingTop: 4 }}>
      <div className="product">
        <div className="main-image-container modelImage">
          <div style={{ display: "inline-block", position: "relative" }}>
            <Image src={resolveImageUrl(props.product?.colors[0].modelImage)} fluid />
            {props.product?.logos && props.product?.logos?.map((logo, index) => (
              <img
                key={index}
                className="logo-image"
                src={apiUrl + logo.decoration_logo.imageUrl}
                width={logo.width + '%'}
                style={{ height: logo.height + '%', left: logo.x + '%', top: logo.y + '%', transform: 'rotate(' + logo.rotate + 'deg)' }}
                alt=""
              />
            ))}
          </div>
        </div>

        <div className="title">{props.product.title}</div>
        {loginStatus && (
          <div className="price">
            ${(props.product.costSingle2X).toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </div>
        )}
        <div style={{ display: "flex", height: "100%" }}>
          <div style={{ width: "100%", textAlign: "center", alignSelf: "flex-end" }}>
            <Button onClick={removeItem}>Remove</Button>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default FeaturedProduct;
